export class ListingAnalytic {
  constructor(
    public id: number,
    public name: string,
    public value: number,
    public change: number,
    public status: 'positive' | 'negative' | 'neutral'
  ) {}
}
